import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
} from '@mui/material';
import {
  TrendingUp as ValueIcon,
  ShowChart as SwingIcon,
  Event as EventIcon,
  CompareArrows as CompareIcon,
} from '@mui/icons-material';
import EventImpactTab from './EventImpactTab';
import ValueStocksTab from './ValueStocksTab';
import SwingTradesTab from './SwingTradesTab';
import DateRangeComparisonTab from './DateRangeComparisonTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`investment-tabpanel-${index}`}
      aria-labelledby={`investment-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 0.5 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `investment-tab-${index}`,
    'aria-controls': `investment-tabpanel-${index}`,
  };
}

const InvestmentStrategies: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box>
      <Paper sx={{ mb: 1 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="Investment strategy tabs"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 36,
            '& .MuiTab-root': {
              minHeight: 36,
              fontSize: '0.85rem',
              py: 0,
            },
          }}
        >
          <Tab
            icon={<CompareIcon />}
            iconPosition="start"
            label="Date Range"
            {...a11yProps(0)}
          />
          <Tab
            icon={<EventIcon />}
            iconPosition="start"
            label="Event Impact"
            {...a11yProps(1)}
          />
          <Tab
            icon={<ValueIcon />}
            iconPosition="start"
            label="Value Stocks"
            {...a11yProps(2)}
          />
          <Tab
            icon={<SwingIcon />}
            iconPosition="start"
            label="Swing Trades"
            {...a11yProps(3)}
          />
        </Tabs>
      </Paper>

      <TabPanel value={selectedTab} index={0}>
        <DateRangeComparisonTab />
      </TabPanel>

      <TabPanel value={selectedTab} index={1}>
        <EventImpactTab />
      </TabPanel>

      <TabPanel value={selectedTab} index={2}>
        <ValueStocksTab />
      </TabPanel>

      <TabPanel value={selectedTab} index={3}>
        <SwingTradesTab />
      </TabPanel>
    </Box>
  );
};

export default InvestmentStrategies;
